module.exports = __webpack_public_path__ + "assets/button.c633b7e1.svg";